import React from 'react';
import * as classes from './FooterSocialMedia.module.scss';
import clsx from 'clsx';
import { VisuallyHidden } from '@react-aria/visually-hidden';

export interface ISocialMediaLink {
    href: string;
    service: 'twitter' | 'linkedin' | 'xing';
    label: string;
}

export interface IFooterSocialMediaProps {
    title: string;
    links: ISocialMediaLink[];
}

export const FooterSocialMedia: React.FunctionComponent<IFooterSocialMediaProps> = props => {
    return (
        <div className={classes.group} role={'group'} aria-label={props.title}>
            {props.links.map((item, i) => (
                <a
                    key={i}
                    href={item.href}
                    className={clsx(classes.link, classes[item.service])}
                    rel="noopener"
                >
                    <VisuallyHidden elementType="span">{item.label}</VisuallyHidden>
                </a>
            ))}
        </div>
    );
};
